import { ConfirmationService } from 'primeng/api';
import { Component, OnInit, ViewChildren, QueryList, ViewChild, Input } from '@angular/core';
import { ItemConfirmComponent } from '@pages/_components/item-confirm/item-confirm.component';
import { MenuServiceInt } from '@core/_services/menu.serviceint';
import { MessagesService } from '@core/_services/messages.service';
import { Table } from 'primeng/table';
import { TabPanelHandler } from '@core/_utils/table.utils';
import { getVisibiliyValue, getGroupListData, getUserListData, loadVisibility } from '@core/_utils/tools.utils';
import { CommonService } from '@service/common.service';
import { TranslateService } from '@ngx-translate/core';
import { customizedScreenRoutes } from '@custom/custom.route';
import { forkJoin, lastValueFrom, map } from 'rxjs';
import { ApiV6Service } from '@service/apiv6.service';
import { docksScreenRoutes } from '../../../docks.route';

@Component({
    selector: 'app-list-custrights',
    templateUrl: './list-custrights.component.html',
    styleUrls: ['./list-custrights.component.scss'],
})
export class ListCustRightsComponent extends TabPanelHandler implements OnInit {
    public value = true;
    public itemConfirm: ItemConfirmComponent;
    public results = [];
    public groupList = [];
    public userList = [];
    public screenList = [];
    public screenBase = [];
    public visibilityList: any[];

    protected _isInRangeTimeout: any;

    public listColumns = [];

    @ViewChildren('p-tabPanel:not(:first-child)')
    public itemChildren: QueryList<any>;

    @ViewChild('dt')
    public dataTable: Table;
    public blockEvent = false;

    @Input()
    public entities: Array<any> = [];

    constructor(
        private api: ApiV6Service,
        public menu: MenuServiceInt,
        protected _messageService: MessagesService,
        public confirmationService: ConfirmationService,
        private commonService: CommonService,
        protected translate: TranslateService
    ) {
        super(translate);
        this.menu.display = true;
        this.visibilityList = [];
        this.visibilityList = loadVisibility(this.translate);
    }

    ngOnInit() {
        this.itemConfirm = new ItemConfirmComponent(this.confirmationService);
        this.listColumns = [
            { header: this.translate.instant('Name'), field: 'name' },
            { header: this.translate.instant('Col_Inti_1'), field: 'label' },
            { header: this.translate.instant('Visibility'), field: 'visibilityLabel' },
            { header: this.translate.instant('Dock'), field: 'typeitem' },
        ];        
        this.findAll();
        this.commonService.checkReset();
    }

    setFilteredList(event) {}

    private async findAll() {
        this.userList = [];
        this.groupList = [];
        this.screenList = [];
        this.screenBase = [];
        
        let wRes: any = {};
        try {
            wRes.data = await lastValueFrom(this.readCustRightData());
        } catch (error) {
            this._messageService.addErrorMsg(this.translate.instant('Load_Data_KO'));
            return;
        }
        this.results = wRes.data.getResultList.data.map((item) => {
            item._label = item.label;
            item.visibilityLabel = getVisibiliyValue(item);           
            return item;
        });
        this.groupList = [...getGroupListData(wRes.data.getGroupList.GroupList)];
        this.userList = [...getUserListData(wRes.data.getUserList.UserList)];
        this.setScreenList(customizedScreenRoutes);
        this.setScreenList(docksScreenRoutes);
        this.screenBase = [...this.screenList];
        this.updateScreenList();
    }

    private setScreenList(aArray) {
        for (const item of aArray) {
            if (item.path !== '') {
                this.screenList.push({ label: item.path, value: item.path });
            } else {
                this.screenList.push({ label: item.outlet, value: item.outlet });
            }
        }
    }

    private readCustRightData() {
        return forkJoin([
            this.api.execUrlAction('getcustomrights', ''),
            this.api.execUrlAction('getuserlist', ''),
            this.api.execUrlAction('getgrouplist', '')]).pipe(
            map(([getResultList, getUserList, getGroupList]) => {
                return { getResultList, getUserList, getGroupList };
            })
        );
    }

    private updateScreenList() {       
        this.screenBase = this.screenBase.filter((item) => {
            return (this.results.find(resItem => {
                return item.value === resItem.name;
            })) === undefined;
        });
    }

    closeTab(event) {
        this.closeTabsheet(event);
        this.index = event.index - 1;
        this.execClose(event);
    }

    validateTab(event) {
        this.results = this.results.map((item) => {
            if (item.id === event.data.entete.id) {
                item.label = event.data.entete.label;
                item.name = event.data.entete.name;
                item.visibility = event.data.entete.visibility;
                item.visibilityLabel = getVisibiliyValue(item);
                item._label = event.data.entete.label;
                item.typeitem = event.data.entete.typeitem === true ? 1 : 0;
                return item;
            } else {
                return item;
            }
        });
        this.results = [...this.results];
        this.closeTab(event);
    }

    addTab(event) {
        event.data.entete.typeitem = event.data.entete.typeitem === true ? 1 : 0;
        this.results.push(event.data.entete);
        this.results = [...this.results];
        this.results = this.results.map((item) => {
            item._label = item.name;
            item.visibilityLabel = getVisibiliyValue(item);
            return item;
        });
        this.closeTabsheet(this._event);
        this.index = this.index - 1;
        this.updateScreenList();       
    }

    deleteTab(event) {
        this.results = this.results.filter((item) => {
            return item.id !== event.data.id;
        });
        this.results = [...this.results];
        this.screenBase = [...this.screenList];
        this.updateScreenList();  
        this.closeTab(event);
    }

    cancelAdd(event) {
        this.closeTabsheet(this._event);
        this.index = this.index - 1;
    }

    handleChange($event) {
        this.index = $event.index;
    }

    confirmDelete(event) {
        this.itemConfirm.confirmAction(
            'delete',
            this.translate.instant('Confirm_DelS', {label: event.data.name}),
            () => {
                this.delete(event);
            }
        );
    }

    public async delete(event) {
        let wRes: any;
        try {
            wRes = await lastValueFrom(this.api.execUrlAction('deletecustomright', event.data.id ));
            this.deleteTab(event);
        } catch (error) {
            this._messageService.addErrorMsg(this.translate.instant('Update_KO'));
        } 
    }

    showDetails(item) {
        item = item.data;
        if (!this.isAlreadySelected(item.id)) {
            this.addElement(item.id, item.name, item.name);
        }
    }

    sortReference(event: any): void {}
}
